'use client';

import { createContext, useContext } from 'react';

// The seeded studio has no Maps key, so the location section would render
// nothing at all and an owner would read the toggle as broken.
export const PREVIEW_ADDRESS = 'Rua Augusta 12, 1100-053 Lisboa';

export const PreviewContext = createContext(false);

export const useIsPreview = () => useContext(PreviewContext);
